export enum OriginClick {
  RATING = 'RATING',
  COMPLETED_COURSE = 'COMPLETED_COURSE'
}

export enum ArrivedFrom {
  CLASSROOM = 'CLASSROOM'
}
